import { getConfig } from "../../../../config/app";

export const getThirdPartySponsors = async (): Promise<string[]> => {
  const thirdPartySponsorsURL = getConfig("thirdPartySponsors.cl");
  const response = await fetch(`${thirdPartySponsorsURL}`);

  if (!response.ok) return [];
  const jsonResponse: Array<{ name: string; active: boolean }> = await response.json();
  const thirdPartySponsors = jsonResponse.filter(({ active }) => active).map(({ name }) => name);

  return thirdPartySponsors;
};

export const isValidThirdPartySponsor = (carDealerName: string, allowedCarDealers: string[]) => {
  if (!carDealerName) return false;
  return allowedCarDealers.includes(carDealerName);
};
